<template>
  <GuestNameCollector v-if="!guestName"/>
  <router-view v-else/>
</template>

<script setup>
import GuestNameCollector from './components/guest-name/GuestNameCollector.vue';
import { guestNameService } from './services/guest-name.service';

const guestName = guestNameService.guestName

guestNameService.init()
</script>

<style>
@import './assets/css/reset.css';
@import './assets/css/animation.css';
@import './assets/css/theme.css';
@import './assets/css/wedding.css';

body {
  font-family: 'Arial', sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #facfcf;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  color: #555;
}

#app {
  text-align: center;
  width: 100%;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
</style>